import { Loader2, MapPin, RefreshCw, HelpCircle, FileCheck2, Gauge } from "lucide-react";
import { Button } from "./ui/button";

const CONF = {
  hoch: "bg-emerald-50 text-emerald-800 border-emerald-200",
  mittel: "bg-amber-50 text-amber-800 border-amber-200",
  niedrig: "bg-red-50 text-red-800 border-red-200",
};
const NEEDED = { ja: "Beleg nötig", nein: "Kein Beleg nötig", unklar: "Unklar" };

const Section = ({ icon: Icon, title, children, testId }) => (
  <div data-testid={testId} className="rounded-xl border border-slate-200 bg-white p-4">
    <div className="mb-2 flex items-center gap-2 text-sm font-bold text-slate-900"><Icon className="h-4 w-4 text-slate-500" />{title}</div>
    {children}
  </div>
);

const Chips = ({ items, testId }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testId}>
    {(items || []).map((t, i) => (
      <span key={i} className="rounded-md border border-slate-200 bg-slate-50 px-2 py-0.5 font-num text-xs text-slate-700">{t}</span>
    ))}
  </div>
);

export const AiExplanation = ({ tx, onReanalyze, busy }) => {
  const ai = tx.ai;
  const header = (
    <div className="flex items-center justify-between">
      <h3 className="font-display text-base font-bold text-slate-900">KI-Erklärung</h3>
      <Button variant="outline" size="sm" onClick={onReanalyze} disabled={busy} data-testid="ai-reanalyze-btn" className="gap-1.5">
        <RefreshCw className={`h-3.5 w-3.5 ${busy ? "animate-spin" : ""}`} /> Neu analysieren
      </Button>
    </div>
  );
  if (!ai || tx.ai_status !== "done")
    return (
      <div className="grid gap-3">
        {header}
        <div data-testid="ai-pending" className="flex items-center gap-2 rounded-xl border border-dashed border-slate-300 bg-white p-4 text-sm text-slate-600">
          {tx.ai_status === "failed" ? <span className="text-red-700">Analyse fehlgeschlagen. Bitte „Neu analysieren“.</span> : <><Loader2 className="h-4 w-4 animate-spin" /> Wird analysiert …</>}
        </div>
      </div>
    );
  return (
    <div className="grid gap-3 fade-up" data-testid="ai-explanation">
      {header}
      <div className="rounded-xl border border-slate-200 bg-white p-4">
        <div className="flex flex-wrap items-center gap-2">
          <span className="font-display text-lg font-bold text-slate-900" data-testid="ai-merchant">{ai.merchant_clean}</span>
          <span className="rounded-md bg-slate-900 px-2 py-0.5 text-xs font-semibold text-white" data-testid="ai-category">{ai.category}</span>
          <span className={`rounded-md border px-2 py-0.5 text-xs font-semibold ${CONF[ai.confidence] || CONF.mittel}`} data-testid="ai-confidence">
            <Gauge className="mr-1 inline h-3 w-3" />Sicherheit: {ai.confidence}
          </span>
        </div>
        <p className="mt-2 text-[15px] leading-relaxed text-slate-700" data-testid="ai-what">
          <span className="font-semibold text-slate-900">Was ist das? </span>{ai.what_is_it}
        </p>
      </div>
      <Section icon={FileCheck2} title="Beleg nötig?" testId="ai-receipt-needed">
        <div className="flex flex-wrap items-center gap-2 text-sm">
          <span className={`rounded-md px-2 py-0.5 font-semibold ${ai.receipt_needed === "nein" ? "bg-slate-100 text-slate-700" : ai.receipt_needed === "ja" ? "bg-amber-100 text-amber-900" : "bg-slate-100 text-slate-700"}`}>
            {NEEDED[ai.receipt_needed] || ai.receipt_needed}
          </span>
          <span className="text-slate-600">Erwartet: <b className="text-slate-900" data-testid="ai-receipt-type">{ai.expected_receipt_type}</b></span>
        </div>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">{ai.receipt_needed_reason}</p>
      </Section>
      <Section icon={MapPin} title="Wo finde ich den Beleg?" testId="ai-where-to-find">
        <ol className="grid gap-2">
          {(ai.where_to_find || []).map((s, i) => (
            <li key={i} className="flex gap-2.5 text-sm leading-relaxed text-slate-700">
              <span className="font-num flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-slate-900 text-[11px] font-semibold text-white">{i + 1}</span>
              <span>{s}</span>
            </li>
          ))}
        </ol>
      </Section>
      <p className="flex items-center gap-1 text-xs text-slate-400"><HelpCircle className="h-3 w-3" />KI-Vorschlag – bitte selbst prüfen.</p>
    </div>
  );
};
